import { Button, Modal, Pagination, Spin, Switch, Table, notification } from "antd";
import { _attach_so, _get_attachable_so } from "common/axios_services";
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { setCount } from "splices/updateCountSplice";

const AttachSoComp = () => {
    const navigate = useNavigate()
    const [attachSOModal, setAttachSOModal] = useState(false);
    const [page, setPage] = useState(1);
    const [total_so, setTotal_so] = useState(0);
    const [page_size, setPage_size] = useState(10);
    const [arrayToDisplay, setArrayToDisplay] = useState([]);
    const [allUsersFetched, setAllUsersFetched] = useState(false);
    const [attachingSo, setAttachingSo] = useState(false);
    const [query, setQuery] = useState("");
    const params = useParams()
    const dispatch = useDispatch()
    const updateCount = useSelector(state => state?.updateCount?.count)

    const openNotificationWithIcon = (type, title, message) => {
        notification[type]({ message: title, placement: 'bottomRight', description: message, });
    };

    const getAvailableSo = async () => {
        setAllUsersFetched(false);
        setArrayToDisplay([]);
        try {
            const get_sales = await _get_attachable_so({ page, page_size, search: query })
            setAllUsersFetched(true);
            setTotal_so(get_sales.data.meta.total);
            setArrayToDisplay(get_sales.data.data);
        } catch (err) {
            setAllUsersFetched(true);
            setArrayToDisplay([]);
            if (err.response) {
                if (err?.response?.data?.message === "Unauthorized") {
                    navigate('/')
                    openNotificationWithIcon('error', err?.response?.data?.title, err.response.data.message)
                } else {
                    openNotificationWithIcon('error', err?.response?.data?.title, err.response.data.message)
                }
            } else {
                openNotificationWithIcon('error', err.message)
            }
        }
    }

    const attachSo = async ({ ref_id, status }) => {
        setAttachingSo(true)
        try {
            const attcah_so = await _attach_so({ ref_id, user_id: params.id, status })
            setAttachingSo(false)
            dispatch(setCount(updateCount + 1))
            openNotificationWithIcon('success', attcah_so?.data?.title, attcah_so?.data?.message)
        } catch (err) {
            setAttachingSo(false)
            if (err.response) {
                if (err?.response?.data?.message === "Unauthorized") {
                    navigate('/')
                    openNotificationWithIcon('error', err?.response?.data?.title, err.response.data.message)
                } else {
                    openNotificationWithIcon('error', err?.response?.data?.title, err.response.data.message)
                }
            } else {
                openNotificationWithIcon('error', err.message)
            }
        }
    }

    let so_list = arrayToDisplay?.map((so) => {
        return {
            radio: (so?.sa_user_id === params?.id) ?
                <>
                    {attachingSo ?
                        <Switch defaultChecked={false} loading /> :
                        <Switch defaultChecked={true} onChange={() => attachSo({ ref_id: so?.so_user_id, status: false })} />}
                </> :
                <>
                    {attachingSo ?
                        <Switch defaultChecked={true} loading /> :
                        <Switch onChange={() => attachSo({ ref_id: so?.so_user_id, status: true })} />}
                </>,
            name: so?.fullname,
            email: so?.email,
            address: so?.address,
        }
    });

    const soList = [
        {
            title: '',
            dataIndex: 'radio',
        },
        {
            title: 'Username',
            className: 'column-number',
            dataIndex: 'name',
            align: 'center',
        },
        {
            title: 'Email',
            className: 'column-number',
            dataIndex: 'email',
            align: 'center',
        },
        {
            title: 'Address',
            className: 'column-number',
            dataIndex: 'address',
            align: 'center',
        },
    ];

    useEffect(() => {
        getAvailableSo()
    }, [page, page_size, query, updateCount])

    const change_page = (selected_page, pageSize) => {
        setPage(selected_page);
        setPage_size(pageSize);
        setAllUsersFetched(false);
        setArrayToDisplay([]);
    }
    return (
        <>
            <Button type="primary" onClick={() => { setAttachSOModal(true); getAvailableSo() }}>Attach SO</Button>
            <Modal centered={true} visible={attachSOModal} onCancel={() => setAttachSOModal(false)} width={720} footer={null}>
                <h5 style={{ marginBottom: "2rem" }}>Attach SO</h5>
                <div className="table-responsive">
                    {allUsersFetched ?
                        <>
                            <Table columns={soList} pagination={false} dataSource={so_list} bordered />
                            <div style={{ marginTop: "2%" }}></div>
                            <Pagination showSizeChanger current={page} total={total_so} showTotal={(total, range) => `${range[0]}-${range[1]} of ${total} users`} defaultPageSize={page_size} onChange={change_page} />
                            <div style={{ marginTop: "2%" }}></div>
                        </>
                        :
                        <div className="">
                            <Spin />
                        </div>
                    }
                </div>
            </Modal>
        </>
    )
}

export default AttachSoComp